export default class Boxes {


    constructor(el) {
        this.$el = jQuery(el);
        this.init();
    }

    init() {
        this.renderCarousel(this.$el.find('.home-news-owl'));
        this.fixTitle();
    }

    fixTitle() {
        let cards = this.$el.find('.home-news-cards');
        jQuery.each(cards.children(), function(indexInArray, valueOfElement) {
            if (jQuery(valueOfElement).find('.card-description').html().length > 50) {
                jQuery(valueOfElement).find('.card-description').html(jQuery(valueOfElement).find('.card-description').html().substr(0, 52) + ' ...')
            }
        });
    }
    setActiveItem(index) {
        let cards = this.$el.find('.home-news-cards');
        let vm = this;
        jQuery.each(cards.children(), function(indexInArray, valueOfElement) {
            jQuery(valueOfElement).hasClass('active') ? jQuery(valueOfElement).removeClass('active') : false;
            jQuery(valueOfElement).on("click", function(e) {
                vm.changeSlide(indexInArray);
            });
        });
        jQuery(cards.children()[index]).addClass('active');

    }

    renderCarousel(carousel) {
        let vm = this;
        carousel.on('changed.owl.carousel', function(e) {
            vm.setActiveItem(e.relatedTarget.relative(e.relatedTarget.current()));
        })
        carousel.owlCarousel({
            loop: false,
            nav: true,
            items: 1,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            animateOut: 'fadeOut',
            autoHeight: true
        });
    }

    changeSlide(index) {
        this.$el.find('.home-news-owl').trigger('to.owl.carousel', [index, 0]);
    }
}
